"use client";
import "./homeHero.css";
import { motion } from "framer-motion";
import { useTranslations } from "next-intl";
import { slideIn } from "@lib/motion";
import RichText from "@components/text/RichText/RichText";
import HoverGradientButton from "@components/buttons/HoverGradientButton/HoverGradientButton";
import TextLink from "@components/buttons/TextLink/TextLink";

export default function HomeHero({ onTakeQuiz }: { onTakeQuiz: () => void }) {
  const t = useTranslations("home");

  return (
    <section id="home-hero" className="home-hero">
      <div className="home-hero-grid">
        <motion.div className="home-hero-left" {...slideIn("left")}>
          <p className="home-hero-eyebrow">{t("hero.eyebrow")}</p>
          <h1 className="home-hero-headline">
            <RichText translationKey="home.hero.headline" />
          </h1>
          <p className="home-hero-body">{t("hero.body")}</p>
          <div className="home-hero-ctas">
            <HoverGradientButton onClick={onTakeQuiz}>{t("cta")}</HoverGradientButton>
            <TextLink href="#how-it-works" variant="orange" className="text-lg">
              {t("hero.seeHow")} →
            </TextLink>
          </div>
        </motion.div>

        <motion.div className="home-hero-right" {...slideIn("right")}>
          <div className="home-hero-orb">
            <div className="orb-shape">
              <div className="orb-inner" />
            </div>
            <p className="orb-caption">{t("hero.orbCaption")}</p>
          </div>

          <div className="home-floater home-floater--top">
            <span className="home-floater-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
                <path d="M12 5c.5 4.5 3 7 7 7-4.5.5-7 3-7 7-.5-4.5-3-7-7-7 4.5-.5 7-3 7-7z" />
              </svg>
            </span>
            <span>
              <span className="home-floater-label">{t("hero.floaterTopLabel")}</span>
              <span className="home-floater-val">{t("hero.floaterTopVal")}</span>
            </span>
          </div>

          <div className="home-floater home-floater--bot">
            <span className="home-floater-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" width="18" height="18">
                <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
                <circle cx="12" cy="12" r="3" fill="currentColor" />
              </svg>
            </span>
            <span>
              <span className="home-floater-label">{t("hero.floaterBotLabel")}</span>
              <span className="home-floater-val">{t("hero.floaterBotVal")}</span>
            </span>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
